import { Divider, Stepper, Text, Title } from "@mantine/core";
import { STAGE_TYPE_LABELS } from "../../lib/format";
import { axioTokens } from "../../theme";
import type { Stage } from "../../types/api";
import { ContentCard } from "../ui";

const COPY = {
  title: "Hiring Flow",
  recruiter:
    "Every candidate you submit must pass through each stage in order. The hiring company moves candidates forward — you'll see live progress on your Submissions page.",
  readOnly:
    "Candidates submitted by your recruiters pass through each stage in order. The hiring company moves them forward.",
} as const;

const STEPPER_NONE_ACTIVE = -1;

export function JobHiringFlow({
  stages,
  caption = "recruiter",
}: {
  stages: Stage[] | undefined;
  caption?: "recruiter" | "readOnly";
}) {
  if (!stages?.length) return null;

  return (
    <ContentCard>
      <Title order={5} mb="md">
        {COPY.title}
      </Title>
      <Divider mb="md" />
      <Stepper
        active={STEPPER_NONE_ACTIVE}
        orientation="horizontal"
        iconSize={axioTokens.unit[32]}
        allowNextStepsSelect={false}
      >
        {stages.map((stage) => (
          <Stepper.Step
            key={stage.id}
            label={stage.name}
            description={STAGE_TYPE_LABELS[stage.stage_type] ?? stage.stage_type}
          />
        ))}
      </Stepper>
      <Text size="xs" c="dimmed" mt="md">
        {COPY[caption]}
      </Text>
    </ContentCard>
  );
}
